/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleoverallvibeweak4Inputs */



/**
* | output |
* | --- |
* | "Catching the overall emotional background of a situation can be hard for you — watching people's tone, gestures and reactions will help you navigate the mood..." |
*
* @param {Eisubscaleoverallvibeweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleoverallvibeweak4 = /** @type {((inputs?: Eisubscaleoverallvibeweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleoverallvibeweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Catching the overall emotional background of a situation can be hard for you — watching people's tone, gestures and reactions will help you navigate the mood of a conversation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta captar el clima emocional general de una situación — observar el tono, los gestos y las reacciones de la gente te ayudará a orientarte mejor.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно уловить общий эмоциональный фон ситуации — наблюдение за тоном, жестами и реакциями людей поможет лучше ориентироваться в атмосфере общения.")
});
export { eisubscaleoverallvibeweak4 as "eiSubscaleOverallVibeWeak" }